$(function() {
  if (!sessionStorage.getItem('loading_anime')) {
    // cookie追加
    // $.cookie('access', 'on', { expires: 1 });

     // loading animation
    $(function() {
      var h = $(window).height();
      $('.main').css('display','none');
      $('#loader-bg ,#loader').height(h).css('display','block');
    });

    $(window).on('load', function () { //全ての読み込みが完了したら実行
      $('#loader-bg').delay(800).fadeOut(2400);
      $('#loader').delay(1200).fadeOut(1900);
      $('#loader').find('img').addClass('logo_anime');
      $('.main').css('display', 'block');
    });

    //10秒たったら強制的にロード画面を非表示
    var stopload = function() {
      $('.main').css('display','block');
      $('#loader-bg').delay(900).fadeOut(800);
      $('#loader').delay(600).fadeOut(300);
    };
    setTimeout(stopload,6000);
    // セッション追加
    sessionStorage.setItem('loading_anime', true);
  }
});
